'use client'
import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC, useEffect, useState } from 'react'

import { PhnxLogoslider } from './Logoslider'
import { LogosliderProps } from './Logoslider'

interface LogosliderBlokProps {
  blok: {
    title: LogosliderProps['title']
    items: any
  } & SbBlokData
}

const Logoslider: FC<LogosliderBlokProps> = ({ blok }) => {
  const [items, setItems] = useState([])
  useEffect(() => {
    if (blok.items) {
      const itemsArray = blok.items.map((item: any) => {
        return {
          asset: {
            src: item.asset.filename,
            alt: item.asset.alt,
          },
        }
      })
      setItems(itemsArray)
    }
  }, [blok.assets])

  return (
    <div {...storyblokEditable(blok)}>
      <PhnxLogoslider title={blok.title} items={items} />
    </div>
  )
}

export default Logoslider
